import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import {
  XMarkIcon,
  // SparklesIcon, // Unused - removed
  // PlusIcon, // Unused - removed
  CpuChipIcon,
  WrenchScrewdriverIcon
} from '@heroicons/react/24/outline';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
`;

const ModalContent = styled.div`
  background: ${theme.colors.background.paper};
  border-radius: ${theme.borderRadius.lg};
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid ${theme.colors.border.primary};
  background: linear-gradient(135deg, ${theme.colors.primary.main} 0%, ${theme.colors.primary.dark} 100%);
  color: white;
`;

const ModalTitle = styled.h2`
  color: white;
  font-size: ${theme.fontSizes.lg};
  font-weight: ${theme.fontWeights.semibold};
  margin: 0;
`;

const ModalBody = styled.div`
  padding: 1.5rem;
  flex: 1;
  overflow-y: auto;
`;

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  background: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  border-radius: ${theme.borderRadius.md};
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }
`;

const OptionCard = styled.div`
  padding: 1rem;
  border: 2px solid ${theme.colors.border.secondary};
  border-radius: ${theme.borderRadius.md};
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 0.75rem;
  
  &:hover {
    border-color: ${theme.colors.primary.main};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(30, 58, 138, 0.15);
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const OptionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
`;

const OptionIcon = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  background: ${theme.colors.primary.light};
`;

const OptionTitle = styled.h3`
  color: ${theme.colors.text.primary};
  font-size: ${theme.fontSizes.lg};
  font-weight: ${theme.fontWeights.semibold};
  margin: 0;
`;

const OptionSubtitle = styled.p`
  color: ${theme.colors.text.secondary};
  font-size: ${theme.fontSizes.sm};
  margin: 0;
`;

const OptionDescription = styled.p`
  color: ${theme.colors.text.secondary};
  font-size: ${theme.fontSizes.sm};
  line-height: 1.5;
  margin: 0 0 1rem 0;
`;

// Removed unused styled components: OptionFeatures, OptionFeature

const StatusBadge = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'available'
})`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem;
  background: ${props => props.available ? theme.colors.primary.main : theme.colors.background.secondary};
  color: ${props => props.available ? 'white' : theme.colors.text.secondary};
  border-radius: ${theme.borderRadius.md};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.medium};
  margin-top: 0.75rem;
  border: ${props => props.available ? 'none' : `1px solid ${theme.colors.border.secondary}`};
`;

const DashboardCreationModal = ({ isOpen, onClose, onCreateAI, onCreateManual }) => {

  const handleManualCreate = () => {
    onCreateManual();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>Create New Dashboard</ModalTitle>
          <CloseButton onClick={onClose}>
            <XMarkIcon className="w-5 h-5" />
          </CloseButton>
        </ModalHeader>
        
        <ModalBody>
          <OptionCard onClick={handleManualCreate}>
            <OptionHeader>
              <OptionIcon style={{ 
                background: `linear-gradient(135deg, ${theme.colors.primary.main}, ${theme.colors.primary.dark})`,
                color: 'white'
              }}>
                🛠️
              </OptionIcon>
              <div>
                <OptionTitle>Start from Scratch</OptionTitle>
                <OptionSubtitle>Build your dashboard manually with complete control</OptionSubtitle>
              </div>
            </OptionHeader>
            
            <OptionDescription>
              Build a custom dashboard step-by-step with complete control over layout and widgets.
            </OptionDescription>
            
            <StatusBadge available={true}>
              <WrenchScrewdriverIcon className="w-3 h-3" />
              Always available
            </StatusBadge>
          </OptionCard>
        </ModalBody>
      </ModalContent>
    </ModalOverlay>
  );
};

export default DashboardCreationModal;